const caches = {
  state: {
    addtemplate: '' // 新增模页面的缓存数据
  },
  mutations: {
    UPDATA_ADDTEMPLATE: (state, mes) => { // 更新新增模板页面的缓存数据
      state.addtemplate = mes
    }
  },
  actions: {
  }
}

export default caches



// WEBPACK FOOTER //
// ./src/store/modules/cache.js